import { render, staticRenderFns } from "./MemberSelect.vue?vue&type=template&id=b98d330a&scoped=true&"
import script from "./MemberSelect.vue?vue&type=script&lang=ts&"
export * from "./MemberSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MemberSelect.vue?vue&type=style&index=0&id=b98d330a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98d330a",
  null
  
)

export default component.exports